module.exports = __webpack_public_path__ + "static/img/organism-h5-1.70cd5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/organism-h5-1.png
// module id = nGIs
// module chunks = 34